export default __webpack_public_path__ + "static/media/icon-edit.bb513b72.svg";